import { useAudienceNameByUuidQuery } from '@occc/graphql';
import { useMemo } from 'react';

export const useGetAudienceNameByUuid = (audienceUuid: string | undefined) => {
  const response = useAudienceNameByUuidQuery({
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
    skip: !audienceUuid,
    variables: { uuid: audienceUuid || '' },
  });

  const node = response.data?.audiences.edges[0]?.node;

  return useMemo(() => {
    return {
      ...response,
      data: node,
    };
  }, [node, response]);
};
